import { styled } from '@mui/material'

export const StyledPageContent = styled('div')`
  height: 100%;
  margin: ${({ theme }) => theme.spacing(2)};
`
